export const ArrowRightInCircle = () => {
    return (
        <svg
            width="28"
            height="28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 27.1A13.09 13.09 0 1 1 14 .9a13.09 13.09 0 1 1 0 26.2Zm0-25.6C7.08 1.5 1.5 7.08 1.5 14S7.08 26.5 14 26.5 26.5 20.92 26.5 14 20.92 1.5 14 1.5ZM2.5 14a11.49 11.49 0 1 1 23 0 11.49 11.49 0 1 1-23 0Z"
                fill="#000"
                stroke="#F8F6DF"
            />
            <path
                d="m13.76 21.76-1.12-1.12L19.28 14l-6.64-6.64 1.12-1.12L21.52 14l-7.76 7.76Z"
                fill="#F8F6DF"
            />
            <path d="M6.8 13.2h13.6v1.6H6.8v-1.6Z" fill="#F8F6DF" />
        </svg>
    );
};
